/**
 * Ssis activity refresh end message.
 */
export interface IExecuteSSISPackageActivityMetadataRefreshStartMessage {
    /**
     * ir name
     */
    irName: string;
}

/**
 * Ssis activity refresh end message.
 */
export interface IExecuteSSISPackageActivityMetadataRefreshEndMessage {
    /**
     * ir name
     */
    irName: string;

    /**
     * Refresh status
     */
    status: string;

    /**
     * Refresh error
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
}

export class ExecuteSSISPackageActivityMetadataRefreshStatus {
    public static readonly STARTED = 'started';

    public static readonly SUCCEEDED = 'succeeded';

    public static readonly FAILED = 'failed';
}
